import { useBreakpointValue } from 'native-base';

export const useIsMobile = () =>
    useBreakpointValue({
        base: true,
        md: false,
    });
